// @flow

const joinArrayOrGetValue = (value: Array<string> | string) => {
  if (Array.isArray(value)) {
    return value.join(' ');
  }

  return value;
};

export default joinArrayOrGetValue;
